import React from 'react';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { useShippingCalculator } from '../shipping-rate-calculator/hooks/use-shipping-calculator';
import { CalculatorSection } from '../shipping-rate-calculator/components/calculator-section';
import { PromotionalSection } from './components/promotional-section';
import style from './freemium-calculator.module.less';
import { FlexRow } from 'ui-components/components/flex';

export const FreemiumShippingRateCalculator = () => {
  const calculatorProps = useShippingCalculator('FREEMIUM_HOME_PAGE_CALCULATOR');

  return (
    <FlexRow className={style['freemium-shipping-calculator']}>
      <CalculatorSection
        {...calculatorProps}
        buttonTheme={THEME_CONSTANTS.primary}
        className={style['calculator-section']}
        stylesheet={style}
        weightContainerClassName={style['weight-number-input']}
        weightInputClassName={style['weight-input']}
      />
      <PromotionalSection />
    </FlexRow>
  );
};
